import { ssoApi } from "@sso/apis";
import { ApiPageResponse, BannedIP } from "@sso/types";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const bannedIPApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.BANNED_IP] }).injectEndpoints({
  endpoints: builder => ({
    bannedIPs: builder.query<ApiPageResponse<BannedIP>, string>({
      query: query => ({ url: `${Endpoints.BANNED_IP}?${query}` }),
      providesTags: [CacheKeys.BANNED_IP],
    }),
  }),
});

export const { useBannedIPsQuery } = bannedIPApi;
